export const loadCss = (url) => {
  let css = document.createElement('link');
  css.href = url;
  css.rel = 'stylesheet';
  css.type = 'text/css';
  document.head.appendChild(css);
}


// WEBPACK FOOTER //
// ./src/Epub/utils/index.js